import { EPrivacySetting } from './chat';

export enum EGroupChatSetting {
  All = 1,
  SelfOnly = 2,
}

export enum ENpcPlotGlobalSettingType {
  GlobalProhibitCreate = 1, // 全局禁止创建
  GlobalProhibitReminder = 2, // 全局禁止提醒、推送
}

export enum EWorkspaceNpcStatus {
  Draft = 1,
  Release = 2,
  ReviewFailed = 3,
  UnderReview = 4,
}

export interface INpcPlotGlobalSettings {
  prohibit_create: boolean; // 禁止创建
  prohibit_reminder: boolean; // 禁止提醒、推送
}

export interface IGetNpcPrivacySettingReq {
  npc_id: number;
}

export interface IGetNpcPrivacySettingResp {
  privacy_setting: EPrivacySetting;
  group_chat_setting: EGroupChatSetting;
  plot_global_settings: INpcPlotGlobalSettings;
}

export interface IUpdateNpcPrivacySettingReq {
  npc_id: number;
  edit_version: number;
  privacy_setting: EPrivacySetting;
}

export interface IUpdateNpcPrivacySettingResp {}

export interface IUpdateNpcGroupChatSettingReq {
  npc_id: number;
  edit_version: number;
  group_chat_setting: EGroupChatSetting;
}

export interface IUpdateNpcGroupChatSettingResp {}

export interface IUpdateNpcPlotSettingReq {
  npc_id: number;
  setting_type: ENpcPlotGlobalSettingType; // 设定类型
  is_remove_prohibit: boolean; // 是否移除禁止项
}

export interface IUpdateNpcPlotSettingResp {}

export interface IDeleteNpcReq {
  npc_id: number;
}

export interface IDeleteNpcResp {}

export interface IUnbindNpcReq {
  npc_id: number;
}

export interface IUnbindNpcResp {}
